/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamLangsIdQueryResponse,
  GetApiV1ExamLangsIdPathParams,
  GetApiV1ExamLangsId401,
  GetApiV1ExamLangsId404,
  GetApiV1ExamLangsId500,
} from "../../types/examEvaluationController/GetApiV1ExamLangsId.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamLangsId } from "../../clients/examEvaluationController/getApiV1ExamLangsId.ts";

export const getApiV1ExamLangsIdQueryKey = (
  id: GetApiV1ExamLangsIdPathParams["id"],
) => [{ url: "/api/v1/exam/langs/:id", params: { id: id } }] as const;

export type GetApiV1ExamLangsIdQueryKey = ReturnType<
  typeof getApiV1ExamLangsIdQueryKey
>;

export function getApiV1ExamLangsIdQueryOptions(
  id: GetApiV1ExamLangsIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamLangsIdQueryKey(id);
  return queryOptions<
    GetApiV1ExamLangsIdQueryResponse,
    ResponseErrorConfig<
      GetApiV1ExamLangsId401 | GetApiV1ExamLangsId404 | GetApiV1ExamLangsId500
    >,
    GetApiV1ExamLangsIdQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamLangsId(id, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna os dados de um idioma de prova pelo seu identificador, para uso no formulário de edição. **(Requer Authorization para autenticação)**
 * @summary Obter idioma de prova por ID (Requer Authorization para autenticação)
 * {@link /api/v1/exam/langs/:id}
 */
export function useGetApiV1ExamLangsId<
  TData = GetApiV1ExamLangsIdQueryResponse,
  TQueryData = GetApiV1ExamLangsIdQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ExamLangsIdQueryKey,
>(
  id: GetApiV1ExamLangsIdPathParams["id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamLangsIdQueryResponse,
        ResponseErrorConfig<
          | GetApiV1ExamLangsId401
          | GetApiV1ExamLangsId404
          | GetApiV1ExamLangsId500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey = resolvedOptions?.queryKey ?? getApiV1ExamLangsIdQueryKey(id);

  const query = useQuery(
    {
      ...getApiV1ExamLangsIdQueryOptions(id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetApiV1ExamLangsId401 | GetApiV1ExamLangsId404 | GetApiV1ExamLangsId500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
